/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ApplicationType,
    ApplicationTypeFromJSON,
    ApplicationTypeFromJSONTyped,
    ApplicationTypeToJSON,
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    GuidIdCodeAndLabel,
    GuidIdCodeAndLabelFromJSON,
    GuidIdCodeAndLabelFromJSONTyped,
    GuidIdCodeAndLabelToJSON,
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface BookingTolerancesFormData
 */
export interface BookingTolerancesFormData {
    /**
     * 
     * @type {string}
     * @memberof BookingTolerancesFormData
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BookingTolerancesFormData
     */
    deleted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BookingTolerancesFormData
     */
    allowEdit?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BookingTolerancesFormData
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BookingTolerancesFormData
     */
    relevance?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BookingTolerancesFormData
     */
    comment?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BookingTolerancesFormData
     */
    disabled?: boolean;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof BookingTolerancesFormData
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {Array<number>}
     * @memberof BookingTolerancesFormData
     */
    brands?: Array<number> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof BookingTolerancesFormData
     */
    markets?: Array<string> | null;
    /**
     * 
     * @type {Array<Int32IdAndLabel>}
     * @memberof BookingTolerancesFormData
     */
    distributionChannels?: Array<Int32IdAndLabel> | null;
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof BookingTolerancesFormData
     */
    suppliers?: Array<GuidIdAndLabel> | null;
    /**
     * 
     * @type {Array<GuidIdCodeAndLabel>}
     * @memberof BookingTolerancesFormData
     */
    carriers?: Array<GuidIdCodeAndLabel> | null;
    /**
     * 
     * @type {ApplicationType}
     * @memberof BookingTolerancesFormData
     */
    applicationType?: ApplicationType;
    /**
     * 
     * @type {string}
     * @memberof BookingTolerancesFormData
     */
    currency?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BookingTolerancesFormData
     */
    toleranceAmountUp?: number | null;
    /**
     * 
     * @type {number}
     * @memberof BookingTolerancesFormData
     */
    toleranceAmountDown?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof BookingTolerancesFormData
     */
    excludeCarriers?: boolean;
}

export function BookingTolerancesFormDataFromJSON(json: any): BookingTolerancesFormData {
    return BookingTolerancesFormDataFromJSONTyped(json, false);
}

export function BookingTolerancesFormDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookingTolerancesFormData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'relevance': !exists(json, 'relevance') ? undefined : json['relevance'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'brands': !exists(json, 'brands') ? undefined : json['brands'],
        'markets': !exists(json, 'markets') ? undefined : json['markets'],
        'distributionChannels': !exists(json, 'distributionChannels') ? undefined : (json['distributionChannels'] === null ? null : (json['distributionChannels'] as Array<any>).map(Int32IdAndLabelFromJSON)),
        'suppliers': !exists(json, 'suppliers') ? undefined : (json['suppliers'] === null ? null : (json['suppliers'] as Array<any>).map(GuidIdAndLabelFromJSON)),
        'carriers': !exists(json, 'carriers') ? undefined : (json['carriers'] === null ? null : (json['carriers'] as Array<any>).map(GuidIdCodeAndLabelFromJSON)),
        'applicationType': !exists(json, 'applicationType') ? undefined : ApplicationTypeFromJSON(json['applicationType']),
        'currency': !exists(json, 'currency') ? undefined : json['currency'],
        'toleranceAmountUp': !exists(json, 'toleranceAmountUp') ? undefined : json['toleranceAmountUp'],
        'toleranceAmountDown': !exists(json, 'toleranceAmountDown') ? undefined : json['toleranceAmountDown'],
        'excludeCarriers': !exists(json, 'excludeCarriers') ? undefined : json['excludeCarriers'],
    };
}

export function BookingTolerancesFormDataToJSON(value?: BookingTolerancesFormData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'deleted': value.deleted,
        'allowEdit': value.allowEdit,
        'description': value.description,
        'relevance': value.relevance,
        'comment': value.comment,
        'disabled': value.disabled,
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'brands': value.brands,
        'markets': value.markets,
        'distributionChannels': value.distributionChannels === undefined ? undefined : (value.distributionChannels === null ? null : (value.distributionChannels as Array<any>).map(Int32IdAndLabelToJSON)),
        'suppliers': value.suppliers === undefined ? undefined : (value.suppliers === null ? null : (value.suppliers as Array<any>).map(GuidIdAndLabelToJSON)),
        'carriers': value.carriers === undefined ? undefined : (value.carriers === null ? null : (value.carriers as Array<any>).map(GuidIdCodeAndLabelToJSON)),
        'applicationType': ApplicationTypeToJSON(value.applicationType),
        'currency': value.currency,
        'toleranceAmountUp': value.toleranceAmountUp,
        'toleranceAmountDown': value.toleranceAmountDown,
        'excludeCarriers': value.excludeCarriers,
    };
}


